module.exports = __webpack_public_path__ + "img/telegram_white.0165a6f2.svg";